import { listTradeHistory } from './tradeHistory';

import { getCoinProperty, getBaseProps } from '@utils/params';
import { getWSLSKey, setWSLSKey } from '@utils/customLib';

const descendingSortNum = (a, b) => (a > b ? -1 : 1);

export const initialTradeOrders = {
	fetchingOpenOrders: false,
	openOrders: [],
	fetchingBracketOrders: false,
	bracketOrders: [],
	bracketOpenOrdersList: [],
	bracketFutureOrdersList: [],
	fetchingStopLossOrders: false,
	stopLossOrders: [],
	fetchingTradeHistory: false,
	tradeHistory: [],
	maxBuy: 0,
	minSell: 0,
	maxBuyVol: 0,
	maxSellVol: 0,
	currentTradingCoin: {
		coin: undefined,
		market_id: undefined,
		coin_id: undefined,
		sym: undefined,
		pair: undefined,
	},
	fetchingTradeOrders: false,
	tradeBuyList: [
		{
			rate: '-',
			btc: '-',
			cumu: '-',
		},
	],
	tradeSellList: [
		{
			rate: '-',
			btc: '-',
			cumu: '-',
		},
	],
	tradeDoneList: [
		{
			rate: '-',
			btc: '-',
			time: '-',
		},
	],
	ramRate: null,
	selectedTradeValues: {
		price: 0,
		vol: 0,
		type: 'buy',
		time: Date.now(),
	},
	autoFillTradePrices: getWSLSKey('autoFillTradePrices') === 1,
	skipConfirmation: getWSLSKey('skipConf') !== '',
	persistMarketChange: getWSLSKey('currMarketCh') !== '',
	currentShownCurrency: getWSLSKey('currChooseSave') || undefined,
	currChooseSave: getWSLSKey('currChooseSave') !== '',
	showCumulative: getWSLSKey('cumu') !== '' ? getWSLSKey('cumu') === 1 : true,
};

const setCurrentTradingCoin = (
	{
		currChooseSave,
		currentShownCurrency,
		currentTradingCoin,
		persistMarketChange,
	},
	tradePair
) => {
	const coinParts = tradePair.split('-');
	const coin = coinParts[0];
	const { market_id, sym, pair } = getBaseProps(coinParts[1]);
	const coin_id = getCoinProperty(coin, 'coinId');

	const conditionOnPersist =
		currentTradingCoin.market_id !== market_id
			? persistMarketChange
				? true
				: false
			: true;

	const newCurrentShownCurrency =
		currChooseSave &&
		currentShownCurrency !== undefined &&
		conditionOnPersist
			? currentShownCurrency
			: market_id;

	return {
		currentTradingCoin: {
			coin,
			market_id,
			coin_id,
			sym,
			pair,
		},
		currentShownCurrency: newCurrentShownCurrency,
		selectedTradeValues: {
			price: 0,
			vol: 0,
			type: 'buy',
		},
	};
};

const fillSelectedTradeValues = (
	{ selectedTradeValues: { type: oldType } },
	vol,
	price,
	type = oldType
) => ({
	selectedTradeValues: {
		price,
		vol,
		type,
		time: Date.now(),
	},
});

// -------------------------------------------------------

export const dashboardActions = ({ action, setState }) => ({
	__setCurrentTradingCoin: setCurrentTradingCoin,
	/**
	 * Reset Orders
	 */
	__resetTradeOrders: () => ({
		openOrders: [],
		bracketOrders: [],
		bracketOpenOrdersList: [],
		bracketFutureOrdersList: [],
		stopLossOrders: [],
	}),

	/**
	 * For Socket
	 */
	__fillBuyList: (_, tradeBuyList) => ({
		tradeBuyList:
			tradeBuyList.length > 0
				? tradeBuyList
				: [
						{
							rate: '-',
							btc: '-',
						},
				  ],
		maxBuy: tradeBuyList[0].rate,
		maxBuyVol: tradeBuyList
			.map(({ btc }) => btc)
			.sort(descendingSortNum)[0],
		fetchingTradeOrders: false,
	}),
	__fillSellList: (_, tradeSellList) => ({
		tradeSellList:
			tradeSellList.length > 0
				? tradeSellList
				: [
						{
							rate: '-',
							btc: '-',
						},
				  ],
		minSell: tradeSellList[0].rate,
		maxSellVol: tradeSellList
			.map(({ btc }) => btc)
			.sort(descendingSortNum)[0],
		fetchingTradeOrders: false,
	}),
	__fillDoneList: (_, tradeDoneList) => ({
		tradeDoneList:
			tradeDoneList.length > 0
				? tradeDoneList
				: [
						{
							rate: '-',
							btc: '-',
							time: '-',
						},
				  ],
		fetchingTradeOrders: false,
	}),
	__fillRamRate: (_, ramRate) => ({
		ramRate,
	}),
	__toggleCurrentShownCurrency: (
		{ currChooseSave },
		currentShownCurrency
	) => {
		if (currChooseSave) {
			setWSLSKey('currChooseSave', currentShownCurrency);
		}
		return {
			currentShownCurrency,
		};
	},
	__fillSelectedTradeValues: fillSelectedTradeValues,
	__fetchingTradeOrders: () => ({
		fetchingTradeOrders: true,
	}),
	__resetTradeLists: () => ({
		tradeBuyList: [],
		tradeSellList: [],
		tradeDoneList: [],
	}),
	__fetchTradeHistory: ({ fetchingTradeHistory }, page) => {
		if (!fetchingTradeHistory) {
			setState({
				fetchingTradeHistory: true,
			});
			action(listTradeHistory)(page);
		}
		return {};
	},
	__resetTradeHistory: () => ({
		tradeHistory: [],
	}),
});
